<template>
  <div class="qrCode">
    <div class="code" id="qrinvitecode"></div>
    <div class="desc">
      <img
        v-lazy="require(`../../../assets/logisticsPDF/info-circle-filled.webp`)"
        alt=""
      />
      <div>扫描此二维码即可查询该单据信息</div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  props: ["qrCode"],
  data() {
    return {};
  },

  mounted() {
    console.log(this.qrCode, "qrcopde+++");
    this.getQRInviteCode();
  },

  methods: {
    getQRInviteCode() {
      new QRCode("qrinvitecode", {
        width: (window.screen.width * 32) / 100,
        height: (window.screen.width * 32) / 100,
        text: this.qrCode,
        render: "table",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.qrCode {
  width: 670px;
  height: 358px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
  .code {
    width: 240px;
    height: 240px;

    margin: 0 auto;
    margin-top: 32px;
  }
  .desc {
    display: flex;
    justify-content: space-between;
    width: 392px;
    height: 30px;

    color: rgba(0, 0, 0, 1);
    font-size: 22px;
    line-height: 30px;
    margin: 0 auto;
    margin-top: 24px;
    div:nth-child(2) {
      width: 370px;
      height: 30px;
    }
    img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
